export default "__VITE_ASSET__9729e7ae__"